<template>
    <div class="print-page">
        <h2>0～6岁儿童心理行为发育复筛转诊单</h2>
        <br/>
        <h4 class="al-center">（第一联 县级妇幼保健机构留存）</h4>
        <br/>
        <div class="d-flex justify-center">
            <h3>编号</h3>
            <input class="squ ml-ns" type="text" readonly :value="it" v-for="it in user.serialNumber"/>
        </div>
        <br/>
        <br/>
        <div class="d-flex justify-center" style="width: 70%; margin: auto; font-size: 18px; font-weight: bold;">
            <span>儿童姓名</span>
            <p class="d-flex-item" style="flex: 2;"><input class="line" type="text" readonly :value="user.name"/></p>
            <span>性别</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$common.sex.find(e => e.value === user.sex).text"/></p>
            <span>出生日期</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$moment(user.birthday).format('YYYY')"/></p>
            <span>年</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$moment(user.birthday).format('MM')"/></p>
            <span>月</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$moment(user.birthday).format('DD')"/></p>
            <span>日</span>
        </div>
        <br/>
        <table border>
            <tr>
                <td width="140">用户ID</td>
                <td colspan="3"><input class="line" type="text" readonly :value="user.hospitalId"/></td>
            </tr>              
            <tr>
                <td width="140">身份证号</td>
                <td colspan="3"><input class="line" type="text" readonly :value="user.idCard"/></td>
            </tr>
            <tr>
                <td>家长姓名</td>
                <td><input class="line" type="text" readonly :value="user.parents.length > 0 ? user.parents[0].name : ''"/></td>
                <td width="140">联系电话</td>
                <td><input class="line" type="text" readonly :value="user.parents.length > 0 ? user.parents[0].phone : ''"/></td>
            </tr>
            <tr>
                <th rowspan="6" class="al-left">转诊原因</th>
                <th colspan="3" class="al-left">病史询问</th>
            </tr>
            <tr>
                <td colspan="3">
                    <span class="mask"/>
                    <ul>
                        <li><input type="checkbox" :checked="data.medicalHistory.text === '' ? true : false"/> 未见明显异常</li>
                        <li><input type="checkbox" :checked="data.medicalHistory.text !== '' ? true : false"/> 存在疑似孤独症症状，具体为 <input class="line" type="text" v-model="data.medicalHistory.text" style="display: inline-block; width: 63.5%;"/></li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th colspan="3" class="al-left">发育量表评估（儿心量表-II）</th>
            </tr>
            <tr>
                <td colspan="3">
                    <span class="mask"/>
                    <ul class="d-flex">
                        <li class="mr-md"><input type="checkbox" :checked="data.dsa.dqScore >= 130 ? true : false"/> 优秀</li>
                        <li class="mr-md"><input type="checkbox" :checked="data.dsa.dqScore >= 110 && data.dsa.dqScore < 130 ? true : false"/> 良好</li>
                        <li class="mr-md"><input type="checkbox" :checked="data.dsa.dqScore >= 80 && data.dsa.dqScore < 110 ? true : false"/> 中等</li>
                        <li class="mr-md"><input type="checkbox" :checked="data.dsa.dqScore >= 70 && data.dsa.dqScore < 80 ? true : false"/> 发育偏离</li>
                        <li class="mr-md"><input type="checkbox" :checked="data.dsa.dqScore < 70 ? true : false"/> 发育障碍</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th colspan="3" class="al-left">孤独症量表筛查</th>
            </tr>
            <tr>
                <td colspan="3">
                    <span class="mask"/>
                    <div class="d-block">
                        <div class="d-flex" v-if="data.mChat.result">项目阳性个数 <input class="d-flex-item line" type="text" :value="(data.mChat.itemPositive ? data.mChat.itemPositive : '')"/></div>
                        <p v-else>&nbsp;</p>
                    </div>

                    <div class="d-block mt-md">
                        <ul v-if="data.abc.totalScore">
                            <li>ABC结果 <input class="line" type="text" v-model="data.abc.totalScore" style="display: inline-block; width: 10%;"/> 分</li>
                            <li class="mr-md"><input type="checkbox" :checked="data.abc.result === 0 ? true : false"/> 未见明显异常</li>
                            <li class="mr-md"><input type="checkbox" :checked="data.abc.result === 1 ? true : false"/> 未通过（存在可疑孤独症症状）</li>
                        </ul>
                        <p v-else>&nbsp;</p>
                    </div>
                </td>
            </tr>
            <tr>
                <th colspan="4" class="al-left">儿童存在以上情况，建议转诊到 <input class="line" type="text" readonly style="display: inline-block; width: 45%;"/> 医疗机构进一步接受复筛</th>
            </tr>
            <tr>
                <th>医生签字</th>
                <td>
                    <input class="line" type="text" readonly/>
                </td>
                <th>填写日期</th>
                <td>
                    <div class="d-flex mt-xs">
                        <input class="d-flex-item line" type="text" readonly/>
                        <span>年</span>
                        <input class="d-flex-item line" type="text" readonly/>
                        <span>月</span>
                        <input class="d-flex-item line" type="text" readonly/>
                        <span>日</span>
                    </div>
                </td>
            </tr>
            <tr>
                <th>医疗机构</th>
                <td colspan="3">
                    <input class="line" type="text" readonly/>
                </td>
            </tr>
        </table>
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            data: Object,
            user: Object,
        },
        data() {
            return {
                value: {}
            }
        },
        async beforeDestroy() {},
        async created() {},
        async mounted() {},
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/prints/fushai_zhuanzhendan.vue